import classNames from 'classnames';
import { format as dateFormat, parse as dateParse } from 'date-fns';
import React from 'react';
import { Detail } from 'react-calendar';
import DatePicker from 'react-date-picker';

import styles from './DatePicker.scss';

const resolution2format = {
  date: 'yyyy-MM-dd',
  month: 'yyyy-MM',
  year: 'yyyy',
};

const resolution2maxDetail: {[prop: string]: Detail} = {
  date: 'month',
  month: 'year',
  year: 'decade',
};

// @todo 'en-US' causes error on changing value.
// const resolution2locale = {
//   year: 'en-US', // Force delete year-suffix in Japanese.
// };

const length2resolution = Object.fromEntries(Object.entries(resolution2format).map(([resolution, format]) => [format.length, resolution])) as {[prop: number]: keyof typeof resolution2format};

const MAX_DATE = new Date(9999, 11, 31);

interface PickerProps {
  date: string;
  disabled?: boolean;
  onChange: (arg: string) => void;
}
export default function picker({date: dateString, disabled, onChange}: PickerProps) {
  const resolution = length2resolution[Math.max(dateString.length, 4)];
  const format = resolution2format[resolution];
  const maxDetail = resolution2maxDetail[resolution];
  // const locale = resolution2locale[resolution];

  const date = dateParse(String(dateString), format, new Date());

  return (
    <DatePicker
      className={classNames(disabled ? styles.disabledDatePicker : styles.datePicker, styles[resolution])}
      // calendarIcon={null}
      clearIcon={null}
      onChange={date => {
        if (date == null) {
          return;
        }
        const dateString = dateFormat(date, format);
        onChange(dateString);
      }}
      maxDetail={maxDetail}
      maxDate={MAX_DATE}
      value={date}
      disabled={disabled}
      // locale={locale}
    />
  );
}

// For use as a component of redux-form's Field
export function pickerFieldComponent({input, disabled}) {
  return picker({date: input.value, disabled, onChange: input.onChange});
}
